<div class="menu-header">
    <p>{{ headerTitle }}</p>
    <div class="logout-button-container">
        <ek-button [icon]="'logout'" [ekStyle]="'outlined'" [severity]="'success'" (click)="onLogoutClick()">
        </ek-button>
    </div>
</div>
<ek-divider></ek-divider>
<ul class="layout-menu">
    <app-menu-item label="MENU.OVERVIEW" *ngIf="canViewOverview" route="/overview"
        (itemClicked)="onMenuItemClick()"></app-menu-item>
    <app-menu-item label="MENU.CHAT" *ngIf="canViewPrivateChat" route="/chat/standalone/private"
        (itemClicked)="onMenuItemClick()"></app-menu-item>
    <app-menu-item label="MENU.STATISTICS" *ngIf="canViewStatistics" route="/statistics"
        (itemClicked)="onMenuItemClick()"></app-menu-item>
    <app-menu-item label="MENU.DOCUMENTS" *ngIf="canViewDocuments" route="/documents"
        (itemClicked)="onMenuItemClick()"></app-menu-item>
    <app-menu-item label="MENU.INGESTION_LINK" *ngIf="canViewIngestionLink" route="/ingestion-link"
        (itemClicked)="onMenuItemClick()"></app-menu-item>
    <app-menu-item *ngIf="canViewConversations" label="MENU.CONVERSATIONS" route="/conversations"
        (itemClicked)="onMenuItemClick()"></app-menu-item>
    <app-menu-item label="MENU.EXAMPLES" *ngIf="canViewExamples" route="/examples"
        (itemClicked)="onMenuItemClick()"></app-menu-item>
    <app-menu-item label="MENU.TESTS" *ngIf="canViewTests" route="/tests"
        (itemClicked)="onMenuItemClick()"></app-menu-item>
    <app-menu-item label="MENU.CHUNKS" *ngIf="canViewChunks" route="/chunks"
        (itemClicked)="onMenuItemClick()"></app-menu-item>
    <app-menu-item label="MENU.PERMISSIONS" *ngIf="canViewPermissions" route="/permissions"
        (itemClicked)="onMenuItemClick()"></app-menu-item>
    <app-menu-item label="MENU.SETTINGS" *ngIf="canViewSettings" route="/settings"
        (itemClicked)="onMenuItemClick()"></app-menu-item>
</ul>
<ek-divider></ek-divider>
<div class="menu-footer">
    <div class="app-version">
        <p>{{ "MENU.FOOTER.TITLE" | translate }}</p>
        <p>{{ "MENU.FOOTER.VERSION" | translate }}</p>
    </div>
    <div class="environment-banner" role="status" *ngIf="isTestEnvironment">
        {{ "ENVIRONMENT.TEST_BANNER" | translate }}
    </div>
</div>